module.exports = __webpack_public_path__ + "img/logo.18aa16f6.png";